import { Subscription } from 'rxjs';

import { ForgetPassObj, ForgetPassResponseDTO } from './../../models/login';
import { Component, OnDestroy, OnInit } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { ReCaptchaV3Service } from "ng-recaptcha";
import { TwfaComponent } from "src/app/components/twfa/twfa.component";
import { AccountService } from "src/app/services/account.service";
import { AlertService } from "src/app/services/alert.service";
import Swal from "sweetalert2";
import { UrlConstants } from 'src/app/models/urlConstants';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit, OnDestroy {



  forgetPassObj: ForgetPassObj = {} as ForgetPassObj
  formForget: FormGroup;
  resetEmail: '';
  companyName=  UrlConstants.companyName;
  private _subscription: Subscription;

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private alertService: AlertService,
    private dialog: MatDialog,
    private translate: TranslateService,
    private accService: AccountService,
    private recaptchaV3Service: ReCaptchaV3Service,
  ) { }

  ngOnInit() {
    this.formForget = this.formBuilder.group({
      email: [null, [Validators.required, Validators.email]],
    });
  }

  // convenience getter for easy access to form fields

  get ff() {
    return this.formForget.controls;
  }





onForget() {
  this.recaptchaV3Service.execute('importantAction')
    .subscribe(
      (token: string) => {
        this.forgetPassObj.Email = this.formForget.value.email;
        this.accService.forgetPassword(this.forgetPassObj)
          .subscribe(
            (response: ForgetPassResponseDTO) => {
              if (response.IsValid) {
                Swal.fire({
                  position: "center",
                  icon: "success",
                  title: this.translate.instant("success-email-sent"),
                  showConfirmButton: false,
                  timer: 4500,
                }).finally(() => {
                  this.router.navigateByUrl('/ForgetPassword');
                });
              } else {
                this.showErrorAlert("error-email-sent");
              }
            },
            (error) => {
              this.showErrorAlert("error-email-sent");
            }
          );
      },
      (error) => {
        this.showErrorAlert("error-email-sent");
      }
    );
}

private showErrorAlert(messageKey: string): void {
  Swal.fire({
    position: "center",
    icon: "error",
    title: this.translate.instant(messageKey),
    showConfirmButton: false,
    timer: 4500,
  });
}

  login() {
    this.router.navigateByUrl('/login');

  }
  ngOnDestroy() {
    if (this._subscription) {
      this._subscription.unsubscribe();
    }
    const element = document.getElementsByClassName('grecaptcha-badge')[0] as HTMLElement;
    if (element) {
      element.style.visibility = 'hidden';
    }
  }
}



